import type { PlanningApplicationFeature } from "react-migration/domains/planning/types";
import { GradientGeoJsonLayer, GradientGeoJsonLayerProps } from "react-migration/lib/map/layers/GradientGeoJsonLayer";
import { getFillColour, getPointRadius, getGradientStop } from "./accessors";

export class PlanningApplicationGeoJsonLayer extends GradientGeoJsonLayer<PlanningApplicationFeature> {
  constructor(...props: Partial<GradientGeoJsonLayerProps<PlanningApplicationFeature>>[]) {
    const [firstProps, ...restProps] = props;

    super(
      {
        ...firstProps,
        stroked: true,
        filled: true,
        lineWidthUnits: "pixels",
        getLineWidth: 2,
        polygonOpacity: 0.6,
        pointRadiusUnits: "pixels",
        getFillColor: getFillColour,
        getLineColor: [255, 255, 255, 255],
        getGradientStopColor: getGradientStop,
        getPointGradientStop: getGradientStop,
        getPointRadius,
      } as unknown as GradientGeoJsonLayerProps<PlanningApplicationFeature>,
      ...(restProps as GradientGeoJsonLayerProps<PlanningApplicationFeature>[])
    );
  }
}
